/* Yorkshire Interiors — The Fabric Atelier
   Progressive enhancement over a server-rendered library.
   The VO options app remains the single source of what can be ordered;
   the yi_cloth metaobjects enrich each cloth with editorial content.
   Nothing here invents a fabric, an image or a fact. */
(function () {
  'use strict';
  var root = document.querySelector('[data-yi-atelier]');
  if (!root || root.hasAttribute('data-yi-ready')) return;
  root.setAttribute('data-yi-ready', '');

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 900px)');
  var dataEl = document.getElementById(root.getAttribute('data-yi-data'));
  var DATA = {};
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = { cloths: [], families: [], text: {} }; }
  var T = DATA.text || {};
  var MAX = parseInt(root.getAttribute('data-yi-max'), 10) || 5;

  function track(event, data) {
    var payload = Object.assign({ event: event }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('yi:analytics', { detail: payload }));
  }
  var HOUSE_NAMES = { boucle: 'Bouclé' };
  function refine(name) {
    var n = (name || '').trim().replace(/\s*fabrics?\s*$/i, '');
    if (HOUSE_NAMES[n.toLowerCase()]) return HOUSE_NAMES[n.toLowerCase()];
    return n.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); });
  }
  function keyOf(family, colour) {
    return (family || '').trim().toLowerCase() + '|' + (colour || '').trim().toLowerCase().replace(/\s*fabrics?\s*$/, '');
  }
  function recipe(url, width) {
    try {
      var parts = url.split('/');
      var cfg = JSON.parse(atob(parts[parts.length - 1]));
      cfg.edits.resize.width = width;
      parts[parts.length - 1] = btoa(JSON.stringify(cfg));
      return parts.join('/');
    } catch (e) { return url; }
  }
  function loadBest(img, url, widths, done) {
    var i = 0;
    function attempt() {
      if (i >= widths.length) { img.src = url; return; }
      img.onerror = function () { i += 1; attempt(); };
      img.onload = function () { img.classList.add('yi-loaded'); if (done) done(); };
      img.src = recipe(url, widths[i]);
    }
    attempt();
  }
  function grace(img) {
    if (img.complete && img.naturalWidth > 0) { img.classList.add('yi-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('yi-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('yi-loaded'); }, { once: true });
  }

  /* ——— the catalogue in memory ——— */
  var cloths = {};           /* key -> record */
  var order = [];            /* keys in display order */
  var families = {};         /* family (exact) -> { name, el, keys[] } */
  DATA.cloths.forEach(function (c) {
    c.key = keyOf(c.family, c.colour);
    c.label = c.display || (refine(c.family) + ' — ' + refine(c.colour));
    c.images = c.images || {};
    Object.keys(c.images).forEach(function (n) { var im = c.images[n]; if (im && im.src2) im.srcset = im.src2 + ' ' + (n === 'bed' ? '2000w' : '1600w') + ', ' + im.src + ' ' + (n === 'bed' ? '1200w' : '800w'); });
    cloths[c.key] = c;
  });

  /* ——— card + family DOM ——— */
  var familiesMount = $('[data-yi-families]');
  function familyEl(name) {
    var el = $$('[data-yi-family]').filter(function (f) { return f.getAttribute('data-yi-family').toLowerCase() === name.toLowerCase(); })[0];
    if (el) return el;
    /* a family the app knows but the theme does not list yet */
    el = document.createElement('section');
    el.className = 'yi-at-family';
    el.setAttribute('data-yi-family', name);
    el.innerHTML = '<div class="yi-at-family__head"><div><span class="yi-at-family__no"></span><h3></h3></div><p class="yi-at-family__intro"></p></div><ul class="yi-at-row" data-yi-row></ul>';
    $('h3', el).textContent = refine(name);
    familiesMount.appendChild(el);
    return el;
  }
  function cardEl(c) {
    var li = document.createElement('li');
    li.className = 'yi-at-cloth';
    li.setAttribute('data-yi-cloth', c.key);
    li.innerHTML =
      '<button type="button" class="yi-at-cloth__view" aria-pressed="false"><span class="yi-at-cloth__img"><img alt="" loading="lazy" width="800" height="1000"></span></button>' +
      '<div class="yi-at-cloth__meta"><div><span class="yi-at-cloth__fam"></span><span class="yi-at-cloth__col"></span></div>' +
      '<button type="button" class="yi-at-add" aria-pressed="false" data-yi-event="yi_swatch_request"><svg class="yi-at-add__plus" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1v10M1 6h10"/></svg><svg class="yi-at-add__tick" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.5l2.8 2.8L10 3.5"/></svg></button></div>';
    return li;
  }
  function hydrateCard(li, c) {
    var img = $('img', li);
    var view = $('.yi-at-cloth__view', li);
    var add = $('.yi-at-add', li);
    $('.yi-at-cloth__fam', li).textContent = c.premium ? refine(c.family) + ' · ' + (T.by_consultation || 'by consultation') : refine(c.family);
    $('.yi-at-cloth__col', li).textContent = c.premium ? refine(c.colour) : refine(c.colour);
    img.alt = c.label + (T.alt_suffix ? ' ' + T.alt_suffix : '');
    view.setAttribute('aria-label', (T.study || 'Study') + ' ' + c.label);
    add.setAttribute('aria-label', (T.add || 'Add') + ' ' + c.label + ' ' + (T.to_parcel || 'to your fabric parcel'));
    add.setAttribute('data-yi-label', c.label);
    var pick = c.images.draped || c.images.macro;
    if (pick) { img.src = pick.src; if (pick.srcset) { img.srcset = pick.srcset; img.sizes = '(max-width:900px) 62vw, 300px'; } grace(img); }
    else if (c.swatch) { loadBest(img, c.swatch, [800, 600, 400]); }
    c.el = li;
    li.setAttribute('data-yi-search', [refine(c.family), refine(c.colour), c.label, c.type, c.tone, c.texture, c.finish].filter(Boolean).join(' ').toLowerCase());
  }
  function placeCards() {
    order = [];
    var famOrder = DATA.families.slice();
    Object.keys(cloths).forEach(function (k) { var f = cloths[k].family; if (famOrder.indexOf(f) < 0) famOrder.push(f); });
    famOrder.forEach(function (fam) {
      var list = Object.keys(cloths).map(function (k) { return cloths[k]; }).filter(function (c) { return c.family === fam && c.orderable; });
      if (!list.length) return;
      list.sort(function (a, b) { return (a.sort || 0) - (b.sort || 0) || (a.index || 0) - (b.index || 0); });
      var fel = familyEl(fam);
      var row = $('[data-yi-row]', fel);
      list.forEach(function (c) {
        var li = $('[data-yi-cloth="' + c.key + '"]', row) || cardEl(c);
        hydrateCard(li, c);
        row.appendChild(li);
        order.push(c.key);
      });
      families[fam] = { name: fam, el: fel, keys: list.map(function (c) { return c.key; }) };
      var mark = $('[data-yi-count]', fel);
      if (mark) mark.textContent = list.length + ' ' + (list.length === 1 ? (T.cloth_one || 'cloth') : (T.cloth_many || 'cloths'));
    });
    /* cards the app no longer offers are withdrawn quietly */
    $$('[data-yi-cloth]').forEach(function (li) {
      var c = cloths[li.getAttribute('data-yi-cloth')];
      if (!c || !c.orderable) li.remove();
    });
    $$('[data-yi-family]').forEach(function (fel) { if (!$('[data-yi-cloth]', fel)) fel.hidden = true; });
  }

  /* ——— the app's catalogue, read at runtime ——— */
  function readApp(then) {
    var src = root.getAttribute('data-yi-source');
    if (!src) { then(false); return; }
    fetch('/products/' + src).then(function (r) { return r.text(); }).then(function (html) {
      var m = html.match(/var bcpo_data\s*=\s*({[\s\S]*?});/);
      if (!m) { then(false); return; }
      var data = JSON.parse(m[1]);
      var vo = data.virtual_options || [];
      var master = vo.filter(function (o) { return o.type === 'buttons' && /fabric/i.test(o.title || ''); })[0];
      if (!master) { then(false); return; }
      var idx = 0;
      master.values.forEach(function (v) {
        var fam = (v.key || '').trim();
        var premium = v.price && parseFloat(v.price) > 0;
        var imgSet = vo.filter(function (o) {
          return o.type === 'images' && o.conditional_option === master.unique && (o.conditional_value || '').trim() === fam;
        })[0];
        if (!imgSet || !imgSet.values) return;
        imgSet.values.forEach(function (cv) {
          if (!cv.value) return;
          var colour = (cv.key || '').trim();
          var key = keyOf(fam, colour);
          var c = cloths[key] || (cloths[key] = { key: key, family: fam, colour: colour, images: {}, label: refine(fam) + ' — ' + refine(colour) });
          c.orderable = true; c.swatch = cv.value; c.premium = !!premium; c.index = idx++;
          if (!c.display) c.label = refine(fam) + ' — ' + refine(colour);
        });
      });
      then(true);
    }).catch(function () { then(false); });
  }

  /* ——— explore: chips, search, edits ——— */
  var chipsEl = $('[data-yi-chips]');
  var searchEl = $('[data-yi-search-input]');
  var statusEl = $('[data-yi-status]');
  var filter = { family: '', query: '', edit: null, editName: '' };
  function buildChips() {
    if (!chipsEl) return;
    chipsEl.innerHTML = '';
    var all = document.createElement('li');
    all.innerHTML = '<button type="button" class="yi-at-chip" data-yi-chip="" aria-pressed="true"></button>';
    $('button', all).textContent = T.all || 'All fabrics';
    chipsEl.appendChild(all);
    Object.keys(families).forEach(function (fam) {
      var li = document.createElement('li');
      li.innerHTML = '<button type="button" class="yi-at-chip" aria-pressed="false"></button>';
      var b = $('button', li);
      b.setAttribute('data-yi-chip', fam);
      var types = families[fam].keys.map(function (k) { return cloths[k].type; }).filter(Boolean);
      b.textContent = (types.length === families[fam].keys.length && types.every(function (t) { return t === types[0]; })) ? types[0] : refine(fam);
      chipsEl.appendChild(li);
    });
    chipsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-yi-chip]');
      if (!b) return;
      filter.family = b.getAttribute('data-yi-chip');
      filter.edit = null; filter.editName = '';
      $$('[data-yi-edit]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      applyFilter();
    });
  }
  function applyFilter() {
    $$('[data-yi-chip]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-yi-chip') === filter.family)); });
    var q = filter.query.trim().toLowerCase();
    var shown = 0;
    Object.keys(families).forEach(function (fam) {
      var f = families[fam];
      var any = false;
      f.keys.forEach(function (k) {
        var c = cloths[k];
        var ok = (!filter.family || filter.family === fam) &&
                 (!filter.edit || filter.edit.indexOf(k) > -1) &&
                 (!q || (c.el.getAttribute('data-yi-search') || '').indexOf(q) > -1);
        c.el.hidden = !ok;
        if (ok) { any = true; shown++; }
      });
      f.el.hidden = !any;
    });
    if (statusEl) {
      var line = '';
      if (filter.editName) line = filter.editName + ' — ' + shown + ' ' + (shown === 1 ? (T.cloth_one || 'cloth') : (T.cloth_many || 'cloths'));
      else if (q || filter.family) line = shown + ' ' + (shown === 1 ? (T.cloth_one || 'cloth') : (T.cloth_many || 'cloths')) + (shown ? '' : ' — ' + (T.none || 'nothing by that name. Try a colour, or a collection.'));
      statusEl.innerHTML = '';
      statusEl.textContent = line;
      if (filter.editName || q || filter.family) {
        var clear = document.createElement('button');
        clear.type = 'button'; clear.className = 'yi-at-chip'; clear.style.marginLeft = '18px';
        clear.textContent = T.show_all || 'Show all';
        clear.addEventListener('click', function () { filter = { family: '', query: '', edit: null, editName: '' }; if (searchEl) searchEl.value = ''; $$('[data-yi-edit]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); applyFilter(); });
        statusEl.appendChild(clear);
      }
    }
  }
  if (searchEl) {
    var t;
    searchEl.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { filter.query = searchEl.value; applyFilter(); if (filter.query) track('yi_fabric_search', { label: filter.query }); }, 180);
    });
  }
  $$('[data-yi-edit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var keys = (b.getAttribute('data-yi-edit') || '').split(',').map(function (s) {
        var p = s.split('|'); return keyOf(p[0], p[1] || '');
      }).filter(function (k) { return cloths[k] && cloths[k].orderable; });
      var on = b.getAttribute('aria-pressed') === 'true';
      $$('[data-yi-edit]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      if (on || !keys.length) { filter.edit = null; filter.editName = ''; applyFilter(); return; }
      b.setAttribute('aria-pressed', 'true');
      filter.edit = keys; filter.editName = b.getAttribute('data-yi-edit-name') || '';
      filter.family = '';
      applyFilter();
      track('yi_edit_open', { label: filter.editName });
      var target = $('[data-yi-collection]');
      if (target) target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    });
    /* the little cloth chips on each edit card */
    var strip = $('[data-yi-edit-cloths]', b);
    if (strip) b.__strip = strip;
  });
  function dressEdits() {
    $$('[data-yi-edit]').forEach(function (b) {
      var keys = (b.getAttribute('data-yi-edit') || '').split(',').map(function (s) { var p = s.split('|'); return keyOf(p[0], p[1] || ''); });
      var strip = b.__strip; var hero = $('[data-yi-edit-img]', b);
      var got = 0;
      keys.forEach(function (k) {
        var c = cloths[k]; if (!c || !c.orderable) return;
        if (strip && got < 4) {
          var s = document.createElement('span'); var im = document.createElement('img'); im.alt = ''; im.loading = 'lazy';
          if (c.images.macro) im.src = c.images.macro.src; else if (c.swatch) im.src = recipe(c.swatch, 120);
          s.appendChild(im); strip.appendChild(s);
        }
        if (hero && !hero.getAttribute('src') && got === 0) {
          var pick = c.images.draped || c.images.macro;
          if (pick) { hero.src = pick.src; if (pick.srcset) hero.srcset = pick.srcset; }
          else if (c.swatch) loadBest(hero, c.swatch, [1200, 1000, 800]);
          hero.alt = c.label;
        }
        got++;
      });
      if (!got) b.closest('[data-yi-edit-card]') && (b.closest('[data-yi-edit-card]').hidden = true);
    });
  }

  /* ——— the parcel ——— */
  var KEY = 'yi-parcel-v2';
  function parcel() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); if (Array.isArray(v)) return v; } catch (e) {}
    /* bring forward anything chosen under the earlier page */
    try {
      var old = JSON.parse(sessionStorage.getItem('yi-parcel') || '[]');
      if (old.length) {
        var moved = old.map(function (label) {
          var k = Object.keys(cloths).filter(function (key) { return cloths[key].label === label; })[0];
          return k ? { key: k } : null;
        }).filter(Boolean);
        saveParcel(moved.slice(0, MAX)); sessionStorage.removeItem('yi-parcel'); return moved.slice(0, MAX);
      }
    } catch (e) {}
    return [];
  }
  function saveParcel(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function inParcel(key) { return parcel().some(function (p) { return p.key === key; }); }
  function thumbFor(c, w) {
    var pick = c.images.macro || c.images.draped;
    if (pick) return pick.src;
    return c.swatch ? recipe(c.swatch, w || 200) : '';
  }
  var tray = $('[data-yi-tray]');
  var trayMinis = $('[data-yi-tray-minis]');
  var trayCount = $('[data-yi-tray-count]');
  var chosenEl = $('[data-yi-chosen]');
  var clothsField = $('[data-yi-cloths]');
  var live = $('[data-yi-live]');
  function say(msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } }

  function addCloth(key, fromEl) {
    var list = parcel();
    if (inParcel(key)) return;
    if (list.length >= MAX) { say((T.full || 'Your parcel holds five cloths. Remove one to add another.')); return; }
    list.push({ key: key });
    saveParcel(list);
    renderParcel(key);
    track('yi_parcel_add', { label: cloths[key].label, count: list.length });
    say(cloths[key].label + ' ' + (T.added_say || 'added to your fabric parcel.') + ' ' + list.length + ' ' + (T.of || 'of') + ' ' + MAX + '.');
    if (fromEl) fly(fromEl, key);
  }
  function removeCloth(key) {
    var list = parcel().filter(function (p) { return p.key !== key; });
    saveParcel(list);
    renderParcel();
    track('yi_parcel_remove', { label: cloths[key] ? cloths[key].label : key, count: list.length });
    say((cloths[key] ? cloths[key].label : '') + ' ' + (T.removed_say || 'removed.'));
  }
  function toggleCloth(key, fromEl) { if (inParcel(key)) removeCloth(key); else addCloth(key, fromEl); }

  function renderParcel(newKey) {
    var list = parcel().filter(function (p) { return cloths[p.key]; });
    var labels = list.map(function (p) { return cloths[p.key].label + (cloths[p.key].premium ? ' (Premium)' : ''); });
    if (clothsField) clothsField.value = labels.join('\n');
    /* cards */
    Object.keys(cloths).forEach(function (k) {
      var c = cloths[k]; if (!c.el) return;
      var on = inParcel(k);
      c.el.classList.toggle('is-in', on);
      var add = $('.yi-at-add', c.el);
      add.setAttribute('aria-pressed', String(on));
      add.setAttribute('aria-label', (on ? (T.remove || 'Remove') : (T.add || 'Add')) + ' ' + c.label + ' ' + (on ? (T.from_parcel || 'from your fabric parcel') : (T.to_parcel || 'to your fabric parcel')));
    });
    /* tray */
    if (tray) {
      var has = list.length > 0;
      tray.classList.toggle('is-open', has);
      tray.setAttribute('aria-hidden', String(!has));
      document.body.classList.toggle('yi-at-has-tray', has);
      trayCount.textContent = list.length + ' ' + (T.of || 'of') + ' ' + MAX + ' ' + (T.samples_selected || 'samples selected');
      trayMinis.innerHTML = '';
      list.forEach(function (p) {
        var c = cloths[p.key];
        var li = document.createElement('li');
        li.className = 'yi-at-mini' + (p.key === newKey ? ' is-new' : '');
        li.innerHTML = '<span class="yi-at-mini__img"><img alt=""></span><span class="yi-at-mini__nm"></span>';
        $('img', li).src = thumbFor(c, 200);
        $('.yi-at-mini__nm', li).textContent = refine(c.colour);
        li.title = c.label;
        trayMinis.appendChild(li);
      });
      for (var i = list.length; i < MAX; i++) {
        var slot = document.createElement('li'); slot.className = 'yi-at-mini yi-at-mini--slot'; slot.setAttribute('aria-hidden', 'true');
        slot.innerHTML = '<span class="yi-at-mini__img"></span>';
        trayMinis.appendChild(slot);
      }
      var addMore = $('[data-yi-tray-add]', tray);
      if (addMore) addMore.hidden = list.length >= MAX;
    }
    /* the review grid in the form */
    if (chosenEl) {
      chosenEl.innerHTML = '';
      if (!list.length) {
        var e = document.createElement('li'); e.className = 'yi-at-chosen__empty';
        e.textContent = T.empty || 'Nothing chosen yet — wander the cloths above.';
        chosenEl.appendChild(e);
      } else {
        list.forEach(function (p) {
          var c = cloths[p.key];
          var li = document.createElement('li');
          li.innerHTML = '<span class="yi-at-chosen__img"><img alt=""></span><span class="yi-at-chosen__nm"></span><button type="button" class="yi-at-chosen__rm" aria-label=""><span aria-hidden="true">×</span></button>';
          $('img', li).src = thumbFor(c, 400); $('img', li).alt = c.label;
          $('.yi-at-chosen__nm', li).textContent = c.label;
          var rm = $('button', li); rm.setAttribute('aria-label', (T.remove || 'Remove') + ' ' + c.label);
          rm.addEventListener('click', function () { removeCloth(p.key); });
          chosenEl.appendChild(li);
        });
        for (var j = list.length; j < MAX; j++) { var s = document.createElement('li'); s.className = 'yi-at-chosen__slot'; s.setAttribute('aria-hidden', 'true'); chosenEl.appendChild(s); }
      }
    }
    syncStoryAdd();
    syncBookAdd();
  }
  /* a cutting placed into the parcel */
  function fly(fromEl, key) {
    if (reduced.matches || !tray || !tray.classList.contains('is-open')) return;
    var img = fromEl.closest('.yi-at-cloth, .yi-at-story, .yi-book__page');
    img = img ? img.querySelector('img') : null;
    var dest = $$('.yi-at-mini:not(.yi-at-mini--slot)', trayMinis).pop();
    if (!img || !dest || mobile.matches) return;
    var a = img.getBoundingClientRect(), b = dest.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var f = document.createElement('div'); f.className = 'yi-at-flier'; f.setAttribute('aria-hidden', 'true');
    var im = document.createElement('img'); im.src = img.currentSrc || img.src; f.appendChild(im);
    f.style.left = a.left + 'px'; f.style.top = a.top + 'px'; f.style.width = a.width + 'px'; f.style.height = a.height + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      f.style.transform = 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px)';
      f.style.width = b.width + 'px'; f.style.height = b.height + 'px';
    }); });
    setTimeout(function () { f.style.opacity = '0'; }, 700);
    setTimeout(function () { f.remove(); }, 1050);
  }
  if (tray) {
    var tg = $('[data-yi-tray-toggle]', tray);
    if (tg) tg.addEventListener('click', function () { var x = tray.classList.toggle('is-expanded'); tg.setAttribute('aria-expanded', String(x)); });
  }
  var form = $('[data-yi-parcel-form]');
  /* mobile number (2026-10-23): UK mobile 07xxxxxxxxx (11 digits, 0044 and +44 forms accepted) or
     international +<country><number> (8–15 digits). Spaces, dashes and brackets are ignored. The field
     is posted as contact[phone], so Shopify also keeps it on the customer record. */
  var tel = form ? $('[data-yi-tel]', form) : null;
  var telErr = form ? $('[data-yi-tel-err]', form) : null;
  function telOk(v) {
    var s = String(v || '').replace(/[\s\-().]/g, '');
    if (!s) return !tel.required;
    if (/^0044/.test(s)) s = '+44' + s.slice(4);
    if (/^\+44/.test(s)) s = '0' + s.slice(3);
    if (/^0/.test(s)) return /^07\d{9}$/.test(s);
    return /^\+[1-9]\d{7,14}$/.test(s);
  }
  function telCheck(report) {
    if (!tel) return true;
    var ok = telOk(tel.value);
    tel.setCustomValidity(ok ? '' : (telErr ? telErr.textContent : 'Please check the mobile number.'));
    tel.setAttribute('aria-invalid', String(!ok));
    tel.closest('.yi-at-form__tel') && tel.closest('.yi-at-form__tel').classList.toggle('is-invalid', !ok);
    if (telErr) telErr.hidden = ok;
    if (!ok && report) { tel.focus(); }
    return ok;
  }
  if (tel) {
    tel.addEventListener('input', function () { if (tel.getAttribute('aria-invalid') === 'true') telCheck(false); });
    tel.addEventListener('blur', function () { if (tel.value) telCheck(false); });
    /* the browser's native bubble is replaced by the inline error */
    tel.addEventListener('invalid', function (e) { if (!telOk(tel.value)) { e.preventDefault(); telCheck(true); } });
  }
  if (form) form.addEventListener('submit', function (e) {
    if (!telCheck(true)) { e.preventDefault(); return; }
    track('yi_parcel_request', { count: parcel().length });
    try { sessionStorage.setItem('yi-parcel-sent', '1'); } catch (e2) {}
  });
  /* once the house has the request, the parcel is emptied */
  if ($('.yi-at-form__sent')) { saveParcel([]); }

  /* ——— the cloth story ——— */
  var story = $('[data-yi-story]');
  var current = null;
  var stageImg = story ? $('[data-yi-stage-img]', story) : null;
  var stage = story ? $('[data-yi-stage]', story) : null;
  var storyAdd = story ? $('[data-yi-story-add]', story) : null;
  var lastFocus = null;
  function visibleOrder() { return order.filter(function (k) { return cloths[k].el && !cloths[k].el.hidden && !cloths[k].el.closest('[hidden]'); }); }
  function imagesOf(c) {
    var list = [];
    if (c.images.draped) list.push({ src: c.images.draped.src, srcset: c.images.draped.srcset, nm: T.img_draped || 'Draped' });
    if (c.images.macro) list.push({ src: c.images.macro.src, srcset: c.images.macro.srcset, nm: T.img_macro || 'The weave' });
    if (c.images.bed) list.push({ src: c.images.bed.src, srcset: c.images.bed.srcset, nm: T.img_bed || 'On a bed' });
    if (c.swatch) list.push({ vo: c.swatch, nm: T.img_swatch || 'Swatch' });
    return list;
  }
  function showImage(entry) {
    if (!stageImg) return;
    stage.classList.add('is-swapping');
    stage.classList.remove('is-inspect');
    var go = function () {
      stageImg.removeAttribute('srcset');
      if (entry.vo) loadBest(stageImg, entry.vo, [1600, 1400, 1200, 1000, 800], function () { stage.classList.remove('is-swapping'); });
      else { stageImg.onload = function () { stage.classList.remove('is-swapping'); }; stageImg.src = entry.src; if (entry.srcset) { stageImg.srcset = entry.srcset; stageImg.sizes = '(max-width:900px) 100vw, 56vw'; } }
    };
    reduced.matches ? go() : setTimeout(go, 220);
  }
  function openStory(key, viaKeyboard) {
    var c = cloths[key]; if (!c || !story) return;
    current = key;
    /* the story sits beneath the family it belongs to */
    var fel = families[c.family] && families[c.family].el;
    if (fel && !mobile.matches && story.previousElementSibling !== fel) fel.insertAdjacentElement('afterend', story);
    $$('.yi-at-cloth').forEach(function (li) { var on = li.getAttribute('data-yi-cloth') === key; li.classList.toggle('is-selected', on); $('.yi-at-cloth__view', li).setAttribute('aria-pressed', String(on)); });
    $('[data-yi-story-eyebrow]', story).textContent = c.premium ? (T.premium_eyebrow || 'The Premium Range') : (T.collection_prefix || 'The') + ' ' + refine(c.family) + ' ' + (T.collection_suffix || 'Collection');
    $('[data-yi-story-title]', story).textContent = c.label;
    var body = $('[data-yi-story-body]', story); body.innerHTML = c.story_html || '';
    var facts = $('[data-yi-story-facts]', story); facts.innerHTML = '';
    var rows = [[T.f_type || 'Type', c.type], [T.f_texture || 'Texture', c.texture], [T.f_tone || 'Tone', c.tone], [T.f_finish || 'Finish', c.finish], [T.f_composition || 'Composition', c.composition], [T.f_reference || 'Reference', c.ref]];
    var fam = families[c.family]; if (fam) rows.push([T.f_colourways || 'Available colourways', String(fam.keys.length)]);
    if (c.premium) rows.push([T.f_availability || 'Availability', T.by_consultation_long || 'Premium range, completed with your designer']);
    rows.forEach(function (r) { if (!r[1]) return; var w = document.createElement('div'); var dt = document.createElement('dt'); dt.textContent = r[0]; var dd = document.createElement('dd'); dd.textContent = r[1]; w.appendChild(dt); w.appendChild(dd); facts.appendChild(w); });
    var care = $('[data-yi-story-care]', story); care.textContent = c.care || '';
    var owner = $('[data-yi-story-owner]', story);
    if (owner) owner.hidden = !!(c.story_html || c.texture || c.tone);
    var bed = $('[data-yi-story-bed]', story);
    if (bed) {
      var first = (c.seen_on && c.seen_on[0]) || null;
      bed.hidden = !first;
      if (first) { bed.href = first.url + (first.url.indexOf('?') > -1 ? '&' : '?') + 'fabric=' + encodeURIComponent(c.family + '|' + c.colour); bed.setAttribute('data-yi-label', c.label); }
    }
    var imgs = imagesOf(c);
    var thumbs = $('[data-yi-thumbs]', story); thumbs.innerHTML = '';
    if (imgs.length > 1) imgs.forEach(function (im, i) {
      var li = document.createElement('li');
      li.innerHTML = '<button type="button" aria-pressed="' + (i === 0) + '"><img alt="" loading="lazy"></button><span></span>';
      $('img', li).src = im.vo ? recipe(im.vo, 200) : im.src; $('span', li).textContent = im.nm;
      $('button', li).setAttribute('aria-label', im.nm);
      $('button', li).addEventListener('click', function () { $$('button', thumbs).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); $('button', li).setAttribute('aria-pressed', 'true'); showImage(im); });
      thumbs.appendChild(li);
    });
    stageImg.alt = c.label;
    showImage(imgs[0] || { src: '' });
    storyAdd.setAttribute('data-yi-label', c.label);
    var bookBtn = $('[data-yi-story-book]', story); if (bookBtn) bookBtn.setAttribute('data-yi-key', key);
    syncStoryAdd();
    var wasHidden = story.hidden;
    story.hidden = false;
    if (mobile.matches) { document.body.style.overflow = 'hidden'; story.scrollTop = 0; }
    if (wasHidden || !mobile.matches) {
      if (!mobile.matches) { var y = story.getBoundingClientRect().top + window.pageYOffset - 24; window.scrollTo({ top: y, behavior: reduced.matches ? 'auto' : 'smooth' }); }
    }
    if (viaKeyboard || mobile.matches) { lastFocus = document.activeElement; $('[data-yi-story-title]', story).setAttribute('tabindex', '-1'); $('[data-yi-story-title]', story).focus({ preventScroll: !mobile.matches }); }
    track('yi_cloth_view', { label: c.label });
  }
  function closeStory() {
    if (!story || story.hidden) return;
    story.hidden = true; document.body.style.overflow = '';
    $$('.yi-at-cloth.is-selected').forEach(function (li) { li.classList.remove('is-selected'); $('.yi-at-cloth__view', li).setAttribute('aria-pressed', 'false'); });
    if (current && cloths[current].el) { $('.yi-at-cloth__view', cloths[current].el).focus({ preventScroll: true }); }
    current = null;
  }
  function stepStory(dir) {
    var vis = visibleOrder(); if (!vis.length) return;
    var i = vis.indexOf(current); if (i < 0) i = 0;
    i = (i + dir + vis.length) % vis.length;
    openStory(vis[i]);
    if (!mobile.matches && cloths[vis[i]].el) cloths[vis[i]].el.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
  }
  function syncStoryAdd() {
    if (!storyAdd || !current) return;
    var on = inParcel(current);
    storyAdd.setAttribute('aria-pressed', String(on));
    $('span', storyAdd).textContent = on ? (T.in_parcel || 'In your fabric parcel') : (T.add_long || 'Add to your fabric parcel');
  }
  if (story) {
    $('[data-yi-story-prev]', story).addEventListener('click', function () { stepStory(-1); });
    $('[data-yi-story-next]', story).addEventListener('click', function () { stepStory(1); });
    $('[data-yi-story-close]', story).addEventListener('click', closeStory);
    storyAdd.addEventListener('click', function () { if (current) toggleCloth(current, storyAdd); });
    var bookBtn = $('[data-yi-story-book]', story);
    if (bookBtn) bookBtn.addEventListener('click', function () { openBook(bookBtn.getAttribute('data-yi-key')); });
    /* inspect the cloth: a magnifier that follows the hand */
    var inspectHint = $('[data-yi-stage-hint]', story);
    function setOrigin(e) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * 100;
      var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height)) * 100;
      stageImg.style.setProperty('--ox', x + '%'); stageImg.style.setProperty('--oy', y + '%');
    }
    stage.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      var on = stage.classList.toggle('is-inspect');
      if (on) setOrigin(e);
      stage.setAttribute('aria-pressed', String(on));
      if (inspectHint) inspectHint.textContent = on ? (T.inspect_off || 'Tap to step back') : (T.inspect_on || 'Inspect the cloth');
      if (on) track('yi_cloth_inspect', { label: cloths[current] ? cloths[current].label : '' });
    });
    stage.addEventListener('pointermove', function (e) { if (stage.classList.contains('is-inspect')) setOrigin(e); });
    stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stage.click(); } });
  }
  root.addEventListener('click', function (e) {
    var view = e.target.closest('.yi-at-cloth__view');
    if (view) { openStory(view.closest('[data-yi-cloth]').getAttribute('data-yi-cloth'), e.detail === 0); return; }
    var add = e.target.closest('.yi-at-add');
    if (add) { toggleCloth(add.closest('[data-yi-cloth]').getAttribute('data-yi-cloth'), add); }
  });
  document.addEventListener('keydown', function (e) {
    if (book && book.classList.contains('is-open')) return;
    if (!story || story.hidden) return;
    if (e.key === 'Escape') closeStory();
    if (e.target.closest && e.target.closest('input, textarea')) return;
    if (e.key === 'ArrowRight') stepStory(1);
    if (e.key === 'ArrowLeft') stepStory(-1);
  });

  /* ——— the house cloth book ——— */
  var book = $('[data-yi-book]');
  var spreads = [];   /* { kind:'chapter'|'cloth', fam, key, n, total } */
  var pos = -1;       /* -1 = cover */
  var turning = false;
  var bookOpener = null;
  function buildSpreads() {
    spreads = [];
    var n = 0;
    Object.keys(families).forEach(function (fam, fi) {
      var f = families[fam];
      spreads.push({ kind: 'chapter', fam: fam, no: fi + 1, keys: f.keys });
      f.keys.forEach(function (k, ki) { n++; spreads.push({ kind: 'cloth', key: k, fam: fam, no: fi + 1, ki: ki + 1, total: f.keys.length }); });
    });
    $('[data-yi-book-total]', book).textContent = n;
  }
  function roman(n) { return ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'][n - 1] || String(n); }
  function leftPage(s) {
    var p = document.createElement('div'); p.className = 'yi-book__page yi-book__page--l';
    if (s.kind === 'chapter') {
      p.classList.add('yi-book__chapter');
      p.innerHTML = '<span class="yi-book__no"></span><h2></h2><p class="yi-book__line"></p><span class="yi-book__count"></span><div class="yi-book__chapter-cloths"></div>';
      $('.yi-book__no', p).textContent = (T.collection_word || 'Collection') + ' ' + roman(s.no);
      $('h2', p).textContent = refine(s.fam);
      var intro = (DATA.intros || {})[s.fam] || '';
      $('.yi-book__line', p).textContent = intro; if (!intro) $('.yi-book__line', p).remove();
      $('.yi-book__count', p).textContent = s.keys.length + ' ' + (s.keys.length === 1 ? (T.cloth_one || 'cloth') : (T.cloth_many || 'cloths'));
      var strip = $('.yi-book__chapter-cloths', p);
      s.keys.forEach(function (k) { var sp = document.createElement('span'); var im = document.createElement('img'); im.alt = ''; im.src = thumbFor(cloths[k], 120); sp.appendChild(im); strip.appendChild(sp); });
      return p;
    }
    var c = cloths[s.key];
    p.innerHTML = '<span class="yi-book__no"></span><h2></h2><div class="yi-book__text"></div><dl class="yi-book__facts"></dl>';
    $('.yi-book__no', p).textContent = refine(s.fam).toUpperCase() + ' · ' + (T.collection_word || 'Collection') + ' ' + roman(s.no);
    $('h2', p).innerHTML = '<span></span><small></small>';
    $('h2 span', p).textContent = refine(c.colour);
    $('h2 small', p).textContent = c.premium ? (T.by_consultation_long || 'Premium range, completed with your designer') : refine(c.family);
    $('.yi-book__text', p).innerHTML = c.story_html || '';
    var facts = $('.yi-book__facts', p);
    [[T.f_type || 'Type', c.type], [T.f_texture || 'Texture', c.texture], [T.f_tone || 'Tone', c.tone], [T.f_finish || 'Finish', c.finish], [T.f_composition || 'Composition', c.composition], [T.f_reference || 'Reference', c.ref]].forEach(function (r) {
      if (!r[1]) return; var w = document.createElement('div'); var dt = document.createElement('dt'); dt.textContent = r[0]; var dd = document.createElement('dd'); dd.textContent = r[1]; w.appendChild(dt); w.appendChild(dd); facts.appendChild(w);
    });
    return p;
  }
  function rightPage(s) {
    var p = document.createElement('div'); p.className = 'yi-book__page yi-book__page--r';
    if (s.kind === 'chapter') {
      p.classList.add('yi-book__chapter');
      var first = cloths[s.keys[0]];
      p.innerHTML = '<div class="yi-book__mount"><div class="yi-book__cutting"><img alt=""></div></div><div class="yi-book__label"><b></b></div>';
      if (first) { var im = $('img', p); var pick = first.images.draped || first.images.macro; if (pick) im.src = pick.src; else if (first.swatch) loadBest(im, first.swatch, [1200, 1000, 800]); im.alt = first.label; }
      $('.yi-book__label b', p).textContent = (T.turn_hint || 'Turn the page to begin');
      return p;
    }
    var c = cloths[s.key];
    p.innerHTML = '<div class="yi-book__mount"><div class="yi-book__cutting"><img alt=""></div></div><div class="yi-book__label"><b></b><button type="button" class="yi-at-btn yi-at-btn--text" data-yi-book-add aria-pressed="false"><span></span> <i class="yi-at-arrow" aria-hidden="true">+</i></button></div>';
    var im = $('img', p); var pick = c.images.draped || c.images.macro;
    if (pick) { im.src = pick.src; if (pick.srcset) { im.srcset = pick.srcset; im.sizes = '(max-width:900px) 100vw, 520px'; } } else if (c.swatch) loadBest(im, c.swatch, [1200, 1000, 800]);
    im.alt = c.label;
    $('.yi-book__label b', p).textContent = refine(s.fam).toUpperCase() + ' ' + (s.ki < 10 ? '0' : '') + s.ki + ' — ' + refine(c.colour).toUpperCase();
    var b = $('[data-yi-book-add]', p); b.setAttribute('data-yi-key', s.key); b.setAttribute('data-yi-label', c.label);
    b.addEventListener('click', function () { toggleCloth(s.key, b); });
    return p;
  }
  function syncBookAdd() {
    if (!book) return;
    $$('[data-yi-book-add]', book).forEach(function (b) {
      var on = inParcel(b.getAttribute('data-yi-key'));
      b.setAttribute('aria-pressed', String(on));
      $('span', b).textContent = on ? (T.in_parcel || 'In your fabric parcel') : (T.add_book || 'Add to my fabric parcel');
      $('.yi-at-arrow', b).textContent = on ? '✓' : '+';
    });
  }
  var vol, cover, spreadEl, single, foot;
  function renderSpread(i) {
    spreadEl.innerHTML = '';
    var s = spreads[i];
    spreadEl.appendChild(leftPage(s)); spreadEl.appendChild(rightPage(s));
    var sp = document.createElement('div'); sp.className = 'yi-book__spine'; spreadEl.appendChild(sp);
    renderSingle(i);
    syncBookAdd();
    updateFoot();
    /* bring the neighbours' images in quietly */
    [i + 1, i - 1].forEach(function (j) { var n = spreads[j]; if (n && n.kind === 'cloth') { var c = cloths[n.key]; var im = new Image(); var pick = c.images.draped || c.images.macro; im.src = pick ? pick.src : (c.swatch ? recipe(c.swatch, 1200) : ''); } });
  }
  function renderSingle(i) {
    single.innerHTML = '';
    var s = spreads[i];
    var p = document.createElement('div'); p.className = 'yi-book__page';
    if (s.kind === 'chapter') { var l = leftPage(s); p.className = l.className.replace('yi-book__page--l', ''); p.innerHTML = l.innerHTML; }
    else {
      var r = rightPage(s), l2 = leftPage(s);
      p.innerHTML = '<span class="yi-book__no">' + $('.yi-book__no', l2).textContent + '</span>' + r.innerHTML + l2.innerHTML.replace(/<span class="yi-book__no">[^<]*<\/span>/, '');
      var b = $('[data-yi-book-add]', p); b.addEventListener('click', function () { toggleCloth(s.key, b); });
    }
    single.appendChild(p);
  }
  function updateFoot() {
    var s = spreads[pos];
    var cl = spreads.filter(function (x) { return x.kind === 'cloth'; });
    var idx = s && s.kind === 'cloth' ? cl.indexOf(s) + 1 : 0;
    $('[data-yi-book-pos]', book).textContent = s ? (s.kind === 'cloth' ? idx + ' / ' + cl.length : refine(s.fam)) : '';
    $('[data-yi-book-prev]', book).disabled = pos <= 0;
    $('[data-yi-book-next]', book).disabled = pos >= spreads.length - 1;
    var dots = $('[data-yi-book-dots]', book); dots.innerHTML = '';
    Object.keys(families).forEach(function (fam) { var d = document.createElement('i'); if (s && s.fam === fam) d.className = 'is-here'; dots.appendChild(d); });
  }
  function turn(dir) {
    if (turning) return;
    var next = pos + dir;
    if (next < 0 || next >= spreads.length) return;
    if (pos === -1) { pos = next; renderSpread(pos); cover.classList.add('is-away'); single.classList.add('is-ready'); track('yi_book_turn', { label: 'open' }); return; }
    if (reduced.matches || mobile.matches) {
      if (mobile.matches && !reduced.matches) {
        var old = $('.yi-book__page', single);
        pos = next; renderSingle(pos); syncBookAdd(); updateFoot();
        var fresh = $('.yi-book__page:last-child', single);
        if (old) { single.insertBefore(old, fresh); old.classList.add(dir > 0 ? 'is-off-l' : 'is-off-r'); setTimeout(function () { old.remove(); }, 600); }
        fresh.classList.add(dir > 0 ? 'is-off-r' : 'is-off-l');
        requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.classList.remove('is-off-r', 'is-off-l'); }); });
      } else { pos = next; renderSpread(pos); }
      return;
    }
    turning = true; vol.classList.add('is-turning');
    var from = spreads[pos], to = spreads[next];
    var leaf = document.createElement('div');
    leaf.className = 'yi-book__leaf' + (dir < 0 ? ' yi-book__leaf--back' : '');
    var front = document.createElement('div'); front.className = 'yi-book__face yi-book__face--front';
    var back = document.createElement('div'); back.className = 'yi-book__face yi-book__face--back';
    if (dir > 0) { front.appendChild(rightPage(from)); back.appendChild(leftPage(to)); }
    else { front.appendChild(leftPage(from)); back.appendChild(rightPage(to)); }
    leaf.appendChild(front); leaf.appendChild(back);
    vol.appendChild(leaf);
    pos = next; renderSpread(pos);
    requestAnimationFrame(function () { requestAnimationFrame(function () { leaf.classList.add('is-turning', dir > 0 ? 'go-fwd' : 'go-back'); }); });
    setTimeout(function () { leaf.remove(); vol.classList.remove('is-turning'); turning = false; }, 900);
    track('yi_book_turn', { label: to.kind === 'cloth' ? cloths[to.key].label : refine(to.fam) });
  }
  function openBook(key) {
    if (!book) return;
    buildSpreads();
    bookOpener = document.activeElement;
    book.classList.add('is-open'); book.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (key) {
      var i = spreads.map(function (s) { return s.key; }).indexOf(key);
      pos = i > -1 ? i : -1;
    } else pos = -1;
    if (pos > -1) { cover.classList.add('is-away'); renderSpread(pos); }
    else { cover.classList.remove('is-away'); spreadEl.innerHTML = ''; single.innerHTML = ''; updateFoot(); }
    $('[data-yi-book-close]', book).focus();
    track('yi_book_open', { label: key ? cloths[key].label : 'cover' });
  }
  function closeBook() {
    book.classList.remove('is-open'); book.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = story && !story.hidden && mobile.matches ? 'hidden' : '';
    if (bookOpener && bookOpener.focus) bookOpener.focus();
  }
  if (book) {
    vol = $('[data-yi-book-vol]', book); cover = $('[data-yi-book-cover]', book); spreadEl = $('[data-yi-book-spread]', book); single = $('[data-yi-book-single]', book); foot = $('.yi-book__foot', book);
    $$('[data-yi-book-open]').forEach(function (b) { b.addEventListener('click', function () { openBook(null); }); });
    $('[data-yi-book-close]', book).addEventListener('click', closeBook);
    $('[data-yi-book-begin]', book).addEventListener('click', function () { turn(1); });
    $('[data-yi-book-prev]', book).addEventListener('click', function () { turn(-1); });
    $('[data-yi-book-next]', book).addEventListener('click', function () { turn(1); });
    book.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeBook(); return; }
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); turn(1); }
      if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); turn(-1); }
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]), a[href], [tabindex="0"]', book).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    /* a swipe turns the page on a phone; a click on the right half turns it on a desktop */
    var sx = null, sy = null;
    book.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    book.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) turn(dx < 0 ? 1 : -1);
    }, { passive: true });
    vol.addEventListener('click', function (e) {
      if (e.target.closest('button, a') || pos === -1) return;
      var r = vol.getBoundingClientRect();
      turn(e.clientX - r.left > r.width / 2 ? 1 : -1);
    });
  }

  /* ——— reveals ——— */
  function reveals() {
    var els = $$('.yi-at-reveal');
    if (!('IntersectionObserver' in window) || reduced.matches) { els.forEach(function (el) { el.classList.add('yi-inview'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('yi-inview'); io.unobserve(e.target); } }); }, { threshold: .08, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ——— deep links: ?cloth=Family|Colour opens that cloth; #cloth-book opens the book ——— */
  function deepLinks() {
    try {
      var q = new URLSearchParams(location.search);
      var c = q.get('cloth'); if (c) { var p = c.split('|'); var k = keyOf(p[0], p[1] || ''); if (cloths[k] && cloths[k].orderable) openStory(k); }
      if (location.hash === '#cloth-book') openBook(null);
      /* ?bed=<handle> from a bed page: name the bed in the parcel form so the studio knows what was being considered */
      var b = q.get('bed');
      if (b && /^[a-z0-9-]+$/.test(b)) {
        var bedIn = root.querySelector('input[name="contact[Bed considered]"]');
        if (bedIn && !bedIn.value) {
          bedIn.value = b.replace(/-/g, ' ');
          fetch('/products/' + b + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) { if (pr && pr.title && bedIn.value === b.replace(/-/g, ' ')) bedIn.value = pr.title; }).catch(function () {});
        }
      }
    } catch (e) {}
  }

  /* ——— begin ——— */
  reveals();
  readApp(function (ok) {
    if (!ok) {
      /* the app could not be read: show what the house has written, mark nothing orderable */
      Object.keys(cloths).forEach(function (k) { cloths[k].orderable = !!(cloths[k].images.draped || cloths[k].images.macro); });
      if (statusEl) statusEl.textContent = T.app_unavailable || 'The full colour library is loading slowly — please try again in a moment.';
    }
    placeCards();
    buildChips();
    dressEdits();
    renderParcel();
    applyFilter();
    deepLinks();
    root.setAttribute('data-yi-loaded', '');
  });
})();
